import createIcon from '../../createIcon';

/**
 * @component @name Brightness3
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC41IDJDNy40NSAyIDYuNDUgMi4xNiA1LjUgMi40NkM5LjU2IDMuNzMgMTIuNSA3LjUyIDEyLjUgMTJDMTIuNSAxNi40OCA5LjU2IDIwLjI3IDUuNSAyMS41NEM2LjQ1IDIxLjg0IDcuNDUgMjIgOC41IDIyQzE0LjAyIDIyIDE4LjUgMTcuNTIgMTguNSAxMkMxOC41IDYuNDggMTQuMDIgMiA4LjUgMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Brightness3 = createIcon('Brightness3', [
  [
    'path',
    {
      d: 'M8.5 2C7.45 2 6.45 2.16 5.5 2.46C9.56 3.73 12.5 7.52 12.5 12C12.5 16.48 9.56 20.27 5.5 21.54C6.45 21.84 7.45 22 8.5 22C14.02 22 18.5 17.52 18.5 12C18.5 6.48 14.02 2 8.5 2Z',
      key: '8p0xia',
    },
  ],
]);

export default Brightness3;
